import { Mail, Eye, Camera, Shuffle, Link2, BarChart2 } from "lucide-react";

const PAINS = [
  { Icon: Mail, title: "Fragmented ticket sources", desc: "Tickets arrive from multiple 811 portals, emails, and spreadsheets with no central intake." },
  { Icon: Eye, title: "No real-time field visibility", desc: "Supervisors can't see where locators are or which tickets are actually in progress." },
  { Icon: Camera, title: "Scattered compliance proof", desc: "Photos, notes, and GPS data live in text threads instead of structured closeout records." },
  { Icon: Shuffle, title: "Manual, inconsistent dispatch", desc: "Ticket assignment depends on who you call, not optimized routing or workload balance." },
  { Icon: Link2, title: "Disconnected operations data", desc: "Billing, payroll, production, and closeout data never connect cleanly." },
  { Icon: BarChart2, title: "Leadership flying blind", desc: "Executives have no live view of SLA performance, damage risk, or productivity trends." },
];

export default function Problem() {
  return (
    <section data-testid="problem-section" className="section-y relative">
      <div className="container-x">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">The Problem</div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
            Locate operations are too important to run on spreadsheets.
          </h2>
          <p className="mt-5 text-lg text-[#94A3B8] leading-relaxed">
            Most teams are patching together emails, portals, texts, and manual trackers. The result is missed tickets, compliance gaps, and zero real-time visibility.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {PAINS.map(({ Icon, title, desc }, i) => (
            <div
              key={title}
              className="reveal group relative rounded-2xl glass p-6 hover:-translate-y-1 hover:border-white/20 transition-all duration-300"
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              <div className="absolute top-0 left-6 right-6 h-px bg-gradient-to-r from-transparent via-[#FB923C] to-transparent opacity-60" />
              <div className="h-11 w-11 rounded-lg bg-[#F97316]/15 grid place-items-center border border-[#F97316]/30 mb-5">
                <Icon size={20} className="text-[#F97316]" />
              </div>
              <h3 className="font-display font-bold text-lg text-white mb-2">{title}</h3>
              <p className="text-sm text-[#94A3B8] leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
